<template>
  <div class="marketing-email-form-content">

    <marketing-email-editor v-if="type === 'STRIPO'"
                            :value="value"
                            :email="email"
                            :view-only="viewOnly"
                            @input="emitInput"
                            @config="emitConfig" />

    <div v-if="type === 'RAW_TEXT'"
         class="marketing-email-form-content-html">
      <button v-if="!viewOnly"
              class="btn marketing-email-editor-actions-item"
              type="button"
              @click="emitConfig">{{$t('message.generics.message.settings')}}</button>

      <html-editor :value="value.htmlContent"
                   :disabled="viewOnly"
                   @input="emitRawTextInput" />
    </div>

    <marketing-email-editor-html v-if="type === 'HTML'"
                                 :value="value.htmlContent"
                                 @config="emitConfig"
                                 @input="emitRawTextInput" />

  </div>
</template>

<script>
import MarketingEmailEditorHtml from "@/components/modules/marketing/email/editor/html/MarketingEmailEditorHtml";
import delayedSubmit from "@mixins/delayed-submit";
import HtmlEditor from "@components/form/HtmlEditor";
import MarketingEmailEditor from "@components/modules/marketing/email/editor/MarketingEmailEditor";
export default {
  components: {
    HtmlEditor,
    MarketingEmailEditor,
    MarketingEmailEditorHtml,
  },

  props: {
    email: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
      default: undefined,
    },
    type: {
      type: String,
      default: undefined,
    },
    viewOnly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isEmailEditor: false,
      delay: 500,
    };
  },

  mixins: [delayedSubmit],

  computed: {},

  created() {},

  methods: {
    emitRawTextInput(text) {
      const emitVal = {
        htmlContent: text,
        cssStyle: "",
      };

      this.$emit("input", emitVal);

      this.delayedSubmit({
        event: "submit",
        value: emitVal,
      });
    },
    emitInput(val) {
      this.$emit("input", val);

      this.delayedSubmit({
        event: "submit",
        value: val,
      });
    },
    emitConfig() {
      this.$emit("config");
    },
  },
};
</script>

<style lang="scss" scoped>
.marketing-email-form-content {
  padding-bottom: 50px;

  .marketing-email-form-content-html {
    position: relative;

    .marketing-email-editor-actions-item {
      position: absolute;
      right: 10px;
      top: 12px;
      background: #fff;
      box-shadow: none;
      border: 1px solid #c4c4c4;
      font-size: 13px;
      padding: 5px 15px;
      margin-right: 10px;

      &.marketing-email-editor-actions-item_email {
        display: flex;
        align-items: center;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>

